<div class="flex position--relative">
  <!-- EDGE -->
  <div
    *ngIf="canBeDeleted"
    class="border--default border--bottom w--4 position--relative"
    [@treeLinkInOut]="animate ? 'added' : null"
    [ngClass]="{
                   'border--left': isLastChild,
                   'br--bottom-left': isLastChild,
                   'h--5': isLastChild
                 }"
    [ngStyle]="{
                    height: isLastChild ? '30px' : '0',
                    top: isLastChild ? '-8px' : '18px',
                    width: isLastChild ? '16px' : '15px'
                 }"
  ></div>

  <!-- NODE -->
  <div class="flex align-items--center">
    <div
      class="
        flex
        align-items--center
        border--all
        border--default
        br--default
        p--2
        background--default
      "
      [@treeNodeInOut]="animate ? 'added' : null"
      [@glowOnAppear]="animate ? 'added' : null"
      (mouseenter)="hovered = true"
      (mouseleave)="hovered = false"
    >
      <!-- DELETE BUTTON -->
      <button
        *ngIf="canBeDeleted"
        taTooltipStatic="Delete"
        aria-label="Delete"
        (click)="clickDelete.emit()"
        [ngStyle]="{
                transform: 'rotate(45deg)',
                opacity: hovered ? '100' : '0',
                transition: 'opacity 500ms',
                cursor: 'pointer',
                position: 'absolute',
                background: 'transparent',
                left: '11px',
                top: '-9px'
              }"
      >
        <ta-icon icon="plus"></ta-icon>
      </button>

      <div class="mr--2 monospace color--dark weight--bold">
        {{ brackets[0] }}<span
          style="display: inline-block; vertical-align: bottom"
          *ngIf="collapsed"
          @growInOutHorizontal
          >...</span
        >{{ brackets[1] }} {{ label }}
      </div>

      <!-- ADD CHILD BUTTON -->
      <button
        taTooltipStatic="Add Child"
        aria-label="Add Child"
        class="pointer background--default"
        (click)="clickAddChild.emit()"
      >
        <ta-icon icon="plus"></ta-icon>
      </button>

      <!-- COLLAPSE BUTTON -->
      <button
        taTooltipStatic="Toggle Open/Closed"
        aria-label="Toggle Open/Closed"
        class="pointer background--default ml--3"
        [@rotate180]="collapsed"
        (click)="clickToggleCollapsed.emit()"
      >
        <ta-icon icon="angle-up"></ta-icon>
      </button>
    </div>
  </div>
</div>
